<template>
    <b-col md="4" class="animated fadeIn fadeOut">
      <b-card
        class="animated fadeIn fadeOut"
        :border-variant="variant[service.id % 3]"
        :header-bg-variant="service.name == 'basic' ? 'info' : (service.name == 'pro' ? 'primary' : 'success')"
      >
      <template v-slot:header >
        <h2 :class="`mb-0 text-center`">
          <b-img class="mr-1" v-if="service.base_price > service.customer_price" style="cursor:pointer" v-bind="ico" src="ico/coupon.ico" alt="discount"></b-img>
          {{service.service_name}}
        </h2>
      </template>
      <b-card-body>
        <!-- 가격 정보 -->
        <b-card-title>
          <span>
            <span v-if="service.base_price != service.customer_price">
              <h2><del>{{service.base_price | dollar}}</del> {{service.customer_price | dollar}}</h2>
            </span>
            <h2 v-else>{{service.base_price | dollar}}</h2>
          </span>
          <!-- <hr v-if="hide_margin"> -->
          <!-- <p class="text-danger" v-if="hide_margin">
            Sales Margin : {{service.partner_price}}
          </p> -->
        </b-card-title>

        <!-- 웹 방화벽 정보 -->
        <b-list-group flush class="font-weight-bold">
          <b-list-group-item >Number of Web Server	: 1	</b-list-group-item>
          <b-list-group-item>
            Support Web Domain : {{service.service.waf_domain < 0 ? `${service.service.waf_domain * -1} +` : service.service.waf_domain }}
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
      <!-- 웹쉘파인더 -->
      <b-card-body v-if="service.service.wsfinder">
        <b-badge variant="danger">
          <h4 class="p-1 m-0">WSFinder</h4>
        </b-badge>
        <b-card-text class="mt-2">
          Anti-Webshell
        </b-card-text>

        <b-list-group flush class="font-weight-bold">
          <b-list-group-item>
            <span>Detection & Blocking</span>
          </b-list-group-item>
          <b-list-group-item>
            <del v-if="!service.service.wsfinder_analysis">
              WebShell Analysis Support
            </del>
            <span v-else>WebShell Analysis Support	</span>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
      <!-- 악성코드 유포 및 경유 -->
      <hr v-if="service.service.wmds_site">
      <b-card-body>
        <b-badge variant="warning" v-if="service.service_name">
          <h4 class="p-1 m-0">WMDS</h4>
        </b-badge>
        <b-card-text class="mt-2">
          malicious Monitors
          <br>
          (malicious distribution)
          <b-list-group flush class="font-weight-bold">
            <b-list-group-item>Max {{ service.service.wmds_page | number }} Pages	</b-list-group-item>
            <b-list-group-item>Monthly {{ service.service.wmds_total | number }} Max	</b-list-group-item>
            <b-list-group-item v-if="service.service.wmds_analysis"> Web Malware Analysis	</b-list-group-item>
          </b-list-group>
        </b-card-text>
      </b-card-body>
      <hr v-if="service.service.waf">
      <b-card-body v-if="service.service.waf">
        <b-badge variant="primary">
          <h4 class="p-1 m-0">WEBCastle(WAF)</h4>
        </b-badge>
        <b-card-text class="mt-2">
          This is a web firewall.
        </b-card-text>
      </b-card-body>
      <b-list-group v-if="service.service.waf" flush class="font-weight-bold">
        <b-list-group-item>
          HTTPS/SSL via WAF
        </b-list-group-item>
        <b-list-group-item>
          Web Application Firewall
        </b-list-group-item>
      </b-list-group>
      <!-- 위변조 -->
      <b-card-body v-if="service.service.integrity">
        <b-badge variant="success">
          <h4>WFDetector</h4>
        </b-badge>
        <br>
        <b-card-text class="mt-2">
          Check website for forgery
        </b-card-text>
      </b-card-body>

      <b-card-body>
        <b-badge class="font-weight-bold lead" variant="dark" >
          <h4 class="p-1 m-0">Support</h4>
        </b-badge>
      </b-card-body>

      <b-list-group flush class="font-weight-bold">
        <b-list-group-item v-if="service.service.technical_support">Dedicated Support Team	</b-list-group-item>
        <b-list-group-item v-if="service.service.install_support">Agent Installation Support	</b-list-group-item>
        <b-list-group-item v-if="service.service.policy_support">Security Policy Setting Support</b-list-group-item>
        <b-list-group-item>
          Email Response <br>
          (
            24x7x365 within
            {{service.service.email_support}}
            hours
          )
        </b-list-group-item>
        <b-list-group-item v-if="service.name == 'premium'">Phone Response</b-list-group-item>
      </b-list-group>

      <!-- <b-card-body v-if="hide_margin">
        <a href="#" class="card-link">Create Join link</a>
      </b-card-body> -->

      <!-- <b-card-footer>This is a footer</b-card-footer> -->

      <!-- <b-card-img src="https://placekitten.com/480/210" alt="Image" bottom></b-card-img> -->
      </b-card>
    </b-col>
</template>
<script>

export default {
  props: ['service', 'hide_margin'],
  watch: {
  },
  data : () => ({
    ico : { width: 45, height: 45, class: 'm1' },
    variant : ['dark', 'success', 'info'],
    text: ['info', 'primary', 'success']
  }),
  computed: {
  },
  methods: {

  },
  created() {
    this.service.name = this.service.service_name.toLowerCase()
    console.log('[partner] plan_Card', 'created');
  },
  destroyed() { console.log('[partner] plan_Card', 'destroyed'); },
  mounted() { console.log('[partner] plan_Card', 'mounted'); },
}
</script>
